/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetRegisterExternalPatientSeedResponse,
  RegisterExternalPatientErrorResponse,
} from './api.schemas';

import { api } from '../util/http';

export const registerExternalPatientSeeds = (seedKey: string, signal?: AbortSignal) => {
  return api<GetRegisterExternalPatientSeedResponse>({
    url: `/api/auth/register-external-patient-seeds/${seedKey}`,
    method: 'GET',
    signal,
  });
};

export const getRegisterExternalPatientSeedsQueryKey = (seedKey?: string) => {
  return [`/api/auth/register-external-patient-seeds/${seedKey}`] as const;
};

export const getRegisterExternalPatientSeedsQueryOptions = <
  TData = Awaited<ReturnType<typeof registerExternalPatientSeeds>>,
  TError = RegisterExternalPatientErrorResponse,
>(
  seedKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof registerExternalPatientSeeds>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRegisterExternalPatientSeedsQueryKey(seedKey);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof registerExternalPatientSeeds>>> = ({
    signal,
  }) => registerExternalPatientSeeds(seedKey, signal);

  return { queryKey, queryFn, enabled: !!seedKey, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof registerExternalPatientSeeds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RegisterExternalPatientSeedsQueryResult = NonNullable<
  Awaited<ReturnType<typeof registerExternalPatientSeeds>>
>;
export type RegisterExternalPatientSeedsQueryError = RegisterExternalPatientErrorResponse;

export function useRegisterExternalPatientSeeds<
  TData = Awaited<ReturnType<typeof registerExternalPatientSeeds>>,
  TError = RegisterExternalPatientErrorResponse,
>(
  seedKey: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof registerExternalPatientSeeds>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof registerExternalPatientSeeds>>,
          TError,
          Awaited<ReturnType<typeof registerExternalPatientSeeds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRegisterExternalPatientSeeds<
  TData = Awaited<ReturnType<typeof registerExternalPatientSeeds>>,
  TError = RegisterExternalPatientErrorResponse,
>(
  seedKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof registerExternalPatientSeeds>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof registerExternalPatientSeeds>>,
          TError,
          Awaited<ReturnType<typeof registerExternalPatientSeeds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRegisterExternalPatientSeeds<
  TData = Awaited<ReturnType<typeof registerExternalPatientSeeds>>,
  TError = RegisterExternalPatientErrorResponse,
>(
  seedKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof registerExternalPatientSeeds>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useRegisterExternalPatientSeeds<
  TData = Awaited<ReturnType<typeof registerExternalPatientSeeds>>,
  TError = RegisterExternalPatientErrorResponse,
>(
  seedKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof registerExternalPatientSeeds>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRegisterExternalPatientSeedsQueryOptions(seedKey, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
